import { UserRole } from '@avanzu/types';

/**
 * Human-readable label for a UserRole. The internal `ADMIN` role is
 * presented to users as "Finance" — that's what it actually represents
 * in the permissions matrix (full access except billing).
 */
export const getRoleLabel = (role: UserRole | string | undefined): string => {
  switch (role) {
    case UserRole.OWNER:
      return 'Owner';
    case UserRole.ADMIN:
      return 'Finance';
    case UserRole.MEMBER:
      return 'Member';
    case UserRole.VIEWER:
      return 'Viewer';
    case UserRole.AVANZU:
      return 'Avanzu';
    default:
      return String(role ?? '');
  }
};

export default getRoleLabel;
